import { useEffect } from 'react';
import Lenis from 'lenis';

// Buttery smooth scroll (disabled when the user prefers reduced motion).
// Exposes the instance on window.__lenis so route changes can jump to top.
// Automatically pauses while a Radix dialog / sheet / drawer locks body scroll,
// so modal + cart-drawer content scrolls natively without fighting Lenis.
export default function SmoothScroll() {
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
        if (mq && mq.matches) return;

        const lenis = new Lenis({
            duration: 1.05,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            touchMultiplier: 1.6,
            wheelMultiplier: 1,
        });
        window.__lenis = lenis;

        let raf = requestAnimationFrame(function loop(time) {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        });

        // Pause Lenis while a Radix modal/drawer locks the body scroll.
        const syncLock = () => {
            const locked = document.body.hasAttribute('data-scroll-locked')
                || document.body.style.overflow === 'hidden'
                || document.documentElement.hasAttribute('data-scroll-locked');
            if (locked) lenis.stop(); else lenis.start();
        };
        const observer = new MutationObserver(syncLock);
        observer.observe(document.body, { attributes: true, attributeFilter: ['data-scroll-locked', 'style'] });
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-scroll-locked'] });

        return () => {
            cancelAnimationFrame(raf);
            observer.disconnect();
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return null;
}
